export default __webpack_public_path__ + "static/media/square.66d7b372.jpg";